<template>
  <div class="switch" @click="switchDisplayMode">
    <div class="my-switch" :class="{'on':displayMode=== this.labelAry[1].label}">
      <div :class="displayMode ===  labelAry[0].label?'year-on':'year-off'">{{ labelAry[0].label }}</div>
      <div :class="displayMode ===  labelAry[1].label?'month-on':'month-off'">{{ labelAry[1].label }}</div>
    </div>
    <div class="priceTip" v-if="num">（价格：{{totalPrice}}r）</div>
  </div>
</template>

<script>
export default {
  name: "myswitch",
  props:{
    labelAry:{
      type:Array,
      default(){
        return []
      }
    },
    num:{
      type:String,
      default(){
        return ''
      }
    },
  },
  data(){
    return {
      displayMode: this.labelAry[0].label,
      price:this.labelAry[0].price,
      totalPrice:0
    }
  },
  methods:{
    //切换年月
    switchDisplayMode() {
      this.displayMode = this.displayMode === this.labelAry[0].label ? this.labelAry[1].label : this.labelAry[0].label
      this.price = this.price === this.labelAry[0].price ? this.labelAry[1].price : this.labelAry[0].price
      this.totalPrice = (this.num*1) * (this.price*1)
      this.$emit('switchDisplayMode', this.displayMode)
    },
  },
  watch:{
    num(val){
      this.totalPrice = (val*1) * (this.price*1)
      this.$emit('switch',this.price)
    },
    price:{
      handler(newVal){
        this.$emit('switch',newVal)
      },
      immediate:true
    }

  }
}
</script>

<style scoped lang="less">
.switch {
  display: flex;
  align-items: center;
  .my-switch {
    position: relative;
    width: 64px;
    height: 24px;
    background: var(--brand-blue-light, #F0EDE8);
    border-radius: 4px;
    border: 1px solid rgba(26, 29, 36, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;

    &.on {
      &::before {
        box-shadow: -1px 0 2px rgba(26, 29, 36, 0.24);
        transform: translateX(100%);
      }
    }

    &::before {
      transition: all 0.25s ease-in-out 0s;
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 50%;
      height: 24px;
      background: var(--brand-blue, #1A1D24);
      box-shadow: 1px 0 2px rgba(26, 29, 36, 0.24);
      border-radius: 4px;
    }
    div {
      position: relative;
      z-index: 2;
      width: 50%;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: var(--brand-blue, #1A1D24);
      user-select: none;
    }
    .year-on,.month-on{
      color: rgba(255, 255, 255, 1);
    }

  }
  .priceTip{
    color: var(--text-muted, #9AA0AC);
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
  }
}

</style>
